import { Component } from '@angular/core';
import { BaseComponent } from '../core/component/base.component';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent extends BaseComponent {}
